import { GetAssetResponseSchema } from "@forgepoint/shared";
import { fetchApi } from "@/lib/api";

/**
 * Fetches the presigned URL for an asset and opens it in a new browser tab.
 * @param assetId - The ID of the asset to download
 */
export const downloadAsset = async (assetId: string): Promise<void> => {
  const response = await fetchApi(`api/assets/${assetId}`, "GET");
  const parsed = GetAssetResponseSchema.safeParse(response);
  if (!parsed.success || !parsed.data.ok) {
    return;
  }
  window.open(parsed.data.data.asset.externalUrl, "_blank");
};

/** Saves an in-memory file through a temporary object URL. */
export function downloadFile(file: File): void {
  const url = URL.createObjectURL(file);
  const link = document.createElement("a");
  link.href = url;
  link.download = file.name;
  link.click();
  URL.revokeObjectURL(url);
}
